import { BrowserRouter as Router } from 'react-router-dom';

// Hooks
import { AppProvider } from '../../../hooks/context';

// Styles

import '../../styles/fonts.css';

// Routes
import {
  RouterAsegurame,
  RouterCatolica,
  RouterProximamente,
} from './routes-white-label';

const AppRouter = () => {
  const proximamente = process.env.REACT_APP_proximamente;

  const whiteLabel = process.env.REACT_APP_WHITE_LABEL;

  if (proximamente === 'true') {
    return <RouterProximamente />;
  }

  const routes = {
    ASEGURAME: <RouterAsegurame />,
    CATOLICA: <RouterCatolica />,
  };

  return (
    <Router>
      <AppProvider>{routes[whiteLabel]}</AppProvider>
    </Router>
  );
};
export default AppRouter;
